<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <nav>
        <v-toolbar
                color="primary"
                dark
                dense
                app
                :absolute="navPositionAbsolute"
        >
            <v-toolbar-side-icon @click="toggleNavDrawer"></v-toolbar-side-icon>
            <v-toolbar-title class="toolbar-title">{{ $route.meta.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <el-date-picker
                    v-model="dateRange"
                    class="date-picker"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    size="small"
                    align="center"
                    v-if="showDatePicker"
                    :clearable="false"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="datePickerOptions"
                    unlink-panels
                    @change="onDatePicked"
            >
            </el-date-picker>
            <div class="separator"></div>
            <v-toolbar-items>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout row v-on="on" full-height align-center class="menu-wrapper">
                            <v-flex>
                                <v-icon>account_circle</v-icon>
                            </v-flex>
                            <v-flex>
                                &nbsp;
                                <strong>{{ username }}</strong>
                            </v-flex>
                        </v-layout>
                    </template>
                    <v-card>
                        <v-list>
                            <v-list-tile avatar>
                                <v-list-tile-avatar>
                                    <v-icon size="35">account_circle</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ currentUser ? currentUser.username : "" }}
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title v-if="currentUser">
                                        {{ currentUser.roles[0] ? currentUser.roles[0].displayName : "" }}
                                        <span v-if="currentUser.organization">
                                            • {{ currentUser.organization.displayName }}
                                        </span>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="editPassword">Change Password</v-btn>
                            <v-btn flat @click="logout">Logout</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>
        <v-navigation-drawer
                app
                v-model="drawer"
                :width="250"
        >
            <v-toolbar
                    class="transparent"
                    height="150px"
                    flat
            >
                <v-img
                    :src="require('@/assets/word_mark_blue.png')"
                    height="auto"
                />
            </v-toolbar>
            <v-list class="pt-0">
                <v-list-tile
                        v-for="item in items"
                        :key="item.title"
                        :to="item.path"
                >
                    <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-group
                        v-if="showUserDashboards"
                        prepend-icon="assessment"
                        value="true"
                        no-action
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>Dashboards</v-list-tile-title>
                        </v-list-tile>
                    </template>

                    <v-list-tile
                            v-for="dashboard in dashboards"
                            :key="dashboard.externalId"
                            :to="`/dashboards/${dashboard.externalId}`"
                    >
                        <v-list-tile-content>
                            <v-list-tile-title>{{ dashboard.name }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list-group>

                <v-list-group
                        v-if="showAdminDashboards"
                        prepend-icon="assessment"
                        value="true"
                        no-action
                >
                    <template v-slot:activator>
                        <v-list-tile>
                            <v-list-tile-title>Dashboards</v-list-tile-title>
                        </v-list-tile>
                    </template>

                    <v-list-group
                            :key="item.organization.externalId"
                            v-for="item in adminDashboards"
                            no-action
                            sub-group
                            value="true"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-title>{{ item.organization.name }}</v-list-tile-title>
                                <v-list-tile-action>
                                    <v-icon>people_outline</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </template>

                        <v-list-tile
                                v-for="dashboard in item.dashboards"
                                :key="dashboard.externalId"
                                :to="`/dashboards/${dashboard.externalId}`"
                        >
                            <v-list-tile-title>{{ dashboard.name }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list-group>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
    import { mapActions, mapState, mapMutations } from "vuex";
    import { last30Days } from "../utils/date.utils";
    import { UserService } from "../services/user.services";
    import current_user from "../mixins/current_user";
    import moment from "moment";

    export default {
        name: 'navigation',

        mixins: [ current_user ],

        data() {
            return {
                drawer: true,
                items: [],
                dateRange: null,
                datePickerOptions: {
                    disabledDate(date) {
                        const today = new Date();
                        today.setHours(23);
                        today.setMinutes(59);
                        today.setSeconds(59);
                        return date > today;
                    },
                    shortcuts: [
                        {
                            text: 'Today',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).toDate();
                                picker.$emit('pick', [start, end]);
                            },
                        },
                        {
                            text: 'Last 7 Days',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(6, 'day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Last 30 Days',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(29, 'day').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Last Week',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).subtract(1, 'weeks').endOf('week').toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(1, 'weeks').startOf('week').toDate();
                                picker.$emit('pick', [start, end]);
                            },
                        },
                        {
                            text: 'Last Month',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).subtract(1, 'months').endOf('month').toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(1, 'months').startOf('month').toDate();
                                picker.$emit('pick', [start, end]);
                            },
                        },
                        {
                            text: 'Last 3 Months',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).subtract(1, 'month').endOf('month').toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(3, 'month').startOf('month').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Last 6 Months',
                            onClick(picker) {
                                const end = moment().hours(23).minutes(59).seconds(59).subtract(1, 'month').endOf('month').toDate();
                                const start = moment().hours(0).minutes(0).seconds(0).subtract(6, 'month').startOf('month').toDate();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ]
                },
            }
        },

        created() {
            this.$router.options.routes
                .filter(route => route.meta.showInNav)
                .filter(route => !!route.meta.roles.find(role => role === this.currentUserRole))
                .forEach(route => {
                    this.items.push({
                        title: route.meta.title,
                        path: route.path,
                        icon: route.meta.icon
                    })
                })

            this.dateRange = last30Days();
            this.onDatePicked();
        },

        methods: {
            toggleNavDrawer() {
                this.drawer = !this.drawer
            },

            onDatePicked() {
                const filter = Object.assign(
                    {}, 
                    this.searchFilter,
                    {
                        from: this.dateRange[0].getTime(),
                        to: this.dateRange[1].getTime()
                    }
                );
                this.setSearchFilter(filter)
            },

            logout() {
                UserService.logout()
                this.$router.push('/login')
            },

            editPassword() {
                this.$emit('editPassword');
            },

            ...mapActions('search', [
                'searchJournals',
                'getSearchStats',
                'resetSearch',
                'getMentionChartData'
            ]),

            ...mapMutations('search', [
                'setSearchFilter'
            ]),
        },

        computed: {
            ...mapState('dashboards', [
                'dashboards',
                'adminDashboards'
            ]),

            showDatePicker() {
                return this.$route.meta.showDatePicker
            },

            username() {
                if (this.currentUser) {
                    return this.currentUser.username
                }
                return ''
            },

            showUserDashboards() {
                return !this.isSuperAdmin && !this.isBindezAdmin && this.dashboards.length > 0
            },
            
            showAdminDashboards() {
                return (this.isSuperAdmin || this.isBindezAdmin) && this.adminDashboards.length > 0
            },

            ...mapState('search', ['searchFilter']),

            navPositionAbsolute() {
                return this.$route.name === "clipping";
            },
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 450px) {
        .toolbar-title {
            display: none;
        }
    }

    .separator {
        margin-left: 15px;
        margin-right: 15px;
    }

    .date-picker {
        max-width: 275px;
    }

    .menu-wrapper {
        cursor: pointer;
    }
</style>
